var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeightCalorieCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weight_calorie_calculator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transparent_backgrounds",
    "data-name": "transparent backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "weight_calorie_calculator"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.22,
    width: 524.55,
    height: 599.49,
    rx: 51.27,
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 66.68,
    width: 374.68,
    height: 151.95,
    rx: 24,
    fill: "#e1ffe1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 297.09,
    width: 74.94,
    height: 74.94,
    rx: 12,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.74,
    y: 297.09,
    width: 74.94,
    height: 74.94,
    rx: 12,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.74,
    y: 446.97,
    width: 74.94,
    height: 74.94,
    rx: 12,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.61,
    y: 297.09,
    width: 74.94,
    height: 224.81,
    rx: 12,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 446.97,
    width: 74.94,
    height: 74.94,
    rx: 12,
    fill: "#7effaa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightCalorieCalculator);
export default __webpack_public_path__ + "static/media/weight_calorie_calculator.eb0358c31bff772e99776339bd22da53.svg";
export { ForwardRef as ReactComponent };